exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.right-align[data-v-5f6768a0]{text-align:right\n}\n", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/views/account/convert-account.vue"],"names":[],"mappings":";AAAA,8BAAa,gBAAgB;CAAC","file":"convert-account.vue","sourcesContent":[".right-align{text-align:right}\n"],"sourceRoot":""}]);

// exports
